export const resetAll = (resetDetails) => {
  const {
    setErrorTextEnabled,
    createProject,
    setProjectName,
    setProjectDescription,
    setSelectedFilters,
    setSelectedJurisdiction,
    setSelectedDataAggregation,
    setSelectedBenefits,
    setSelectedWorkforces,
    setSelectedPOI,
    setSelectedTrendAnalysis,
    setSelectedPersona,
    setSelectedChatbot,
    setSelectedChatbotExport,
    setSelectedChatbotCopy,
    setSelectedExportToggle,
    currentGroupName,
    currentDescription,
    filters,
    currentFilters,
    dataAggregation,
    currentDataAggregation,
    currentUseCases,
    setSelectedUseCases,
    jurisdiction,
    currentJurisdiction,
    benefits,
    currentBenefits,
    workforces,
    currentWorkforces,
    trendAnalysisFlag,
    personaFlag,
    chatbotFlag,
    chatbotExportFlag,
    chatbotCopyFlag,
    exportFlag,
    setInputDisabled,
    currentPOI,
    pointOfInterestsData
  } = resetDetails
  setErrorTextEnabled(false)
  if (createProject) {
    setProjectName('')
    setProjectDescription('')
    setSelectedFilters([])
    setSelectedUseCases([])
    setSelectedJurisdiction([])
    setSelectedDataAggregation([])
    setSelectedBenefits([])
    setSelectedWorkforces([])
    setSelectedPOI([])
    setSelectedTrendAnalysis([0])
    setSelectedPersona([0])
    setSelectedChatbot([0])
    setSelectedChatbotExport([0])
    setSelectedChatbotCopy([0])
    setSelectedExportToggle([0])
  } else {
    setProjectName(currentGroupName)
    setProjectDescription(currentDescription)
    setSelectedFilters(
      filters.filter(
        (option) => currentFilters && currentFilters.length > 0 && currentFilters.includes(option.FILTER_KEY)
      ) || []
    )
    setSelectedUseCases(currentUseCases)
    setSelectedJurisdiction(jurisdiction.filter((option) => currentJurisdiction.includes(option.STATE_ID)))
    setSelectedDataAggregation(dataAggregation.filter((option) => currentDataAggregation.includes(option.key)) || [])
    setSelectedBenefits(
      benefits.filter(
        (option) => currentBenefits && currentBenefits.length > 0 && currentBenefits.includes(option.id)
      ) || []
    )
    setSelectedWorkforces(
      workforces.filter(
        (option) => currentWorkforces && currentWorkforces.length > 0 && currentWorkforces.includes(option.id)
      ) || []
    )
    setSelectedTrendAnalysis(trendAnalysisFlag)
    setSelectedPersona(personaFlag)
    setSelectedChatbot(chatbotFlag)
    setSelectedChatbotExport(chatbotExportFlag || [0])
    setSelectedChatbotCopy(chatbotCopyFlag || [0])
    setSelectedExportToggle(exportFlag)
    setInputDisabled(true)
    setSelectedPOI(
      pointOfInterestsData.filter(
        (option) => currentPOI && currentPOI.length > 0 && currentPOI.includes(option.POI_ID)
      ) || []
    )
  }
}
